import * as Yup from 'yup';

import strings from '../../../../localization';

const validator = () =>
  Yup.object().shape({
    totalCredits: Yup.number()
      .typeError(strings.pleaseEnterValidNumber)
      .required(strings.requiredField)
      .integer(strings.pleaseEnterValidNumber)
      .min(0, strings.pleaseEnterValidNumber),
    validUntil: Yup.string().required(strings.requiredField),
  });

export default validator;
